<template>
  <el-form>
    <el-row :gutter="24">
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('search')"
          class="material-style"
        >
          <el-input
            :value="mixFiltersFields.search"
            @input="mixFiltersFields.search = valueTrimLeft($event)"
            @change="mixApplyFilter"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('po')"
          class="material-style"
        >
          <el-input
            :value="mixFiltersFields.po"
            @input="mixFiltersFields.po = valueTrimLeft($event)"
            @change="mixApplyFilter"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('customer')"
          class="material-style"
        >
          <select-response-auto-complete
            :model.sync="mixFiltersFields.customerID"
            api="Companies/GetAllDynamic"
            :fields="{ id: 'id', title: 'name' }"
            templateFilter='name.StartsWith("${data.search}")'
            @on-change="mixApplyFilter"
          ></select-response-auto-complete>
        </el-form-item>
      </el-col>
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('part')"
          class="material-style"
        >
          <select-response-auto-complete
            :model.sync="mixFiltersFields.partID"
            api="Parts/GetAllDynamic"
            selected="id,partNumber,partDescription,remark"
            searchAllColumns
            :columns="columnsPart"
            :fields="{ id: 'id', title: 'partNumber' }"
            @on-change="mixApplyFilter"
          ></select-response-auto-complete>
        </el-form-item>
      </el-col>
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('employee')"
          class="material-style"
        >
          <select-response
            :model.sync="mixFiltersFields.orderPhasePersonInChargeEmployeeID"
            :data="dataSourceEmployee.records"
            :isLoading="dataSourceEmployee.isLoading"
            @on-change="mixApplyFilter"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('custom-filters')"
          class="material-style"
        >
          <select-response
            :model.sync="mixFiltersFields.custom"
            :data="dataSourceCustomFilters"
            @on-change="mixApplyFilter"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :xl="8" :lg="6" :span="12">
        <el-form-item
          :label="L10n('order-by')"
          class="material-style"
        >
          <activity-select-order
            :value="orderBy"
            @on-change="(id) => $emit('update:orderBy', id)"
          />
        </el-form-item>
      </el-col>
      <el-col :xl="4" :lg="6" :span="12">
        <el-form-item
          :label="L10n('order-phase')"
          class="material-style"
        >
          <select-response
            :model.sync="mixFiltersFields.orderPhaseID"
            :data="dataSourceOrderPhase.records"
            :isLoading="dataSourceOrderPhase.isLoading"
            @on-change="mixApplyFilter"
          ></select-response>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import Filters from '@/mixins/Filters'
import { filterStartsWith, ORDER_PHASE_CLOSE } from '@/utils/shared'
export default {
  name: 'TopPanel',
  mixins: [Filters],
  components: {
    'activity-select-order': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/Activity/SelectOrderBy')
  },
  mounted () {
    this.mixApplyFilter()
  },
  props: {
    orderBy: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      mixFiltersFields: {
        search: '',
        po: '',
        customerID: '',
        partID: '',
        orderPhasePersonInChargeEmployeeID: null,
        custom: '',
        orderPhaseID: 'ACTIVE'
      },
      mixFiltersConfig: {
        search: {
          // eslint-disable-next-line
          template: 'company.name.contains("${data.value}")'
        },
        orderPhasePersonInChargeEmployeeID: {
          template: (data) => `orderPhasePersonInChargeEmployeeID == ${data.value}`
        },
        // eslint-disable-next-line
        customerID: { template: "customerID == ${data.value}" },
        // eslint-disable-next-line
        partID: { template: 'partID == ${data.value}' },
        // eslint-disable-next-line
        custom: { template: '${data.value}' },
        orderPhaseID: {
          template: (data) => {
            if (!data.value) return ''
            if (data.value === 'ACTIVE') {
              return `orderPhaseID!=${ORDER_PHASE_CLOSE}`
            }
            return `orderPhaseID=="${data.value}"`
          }
        }
      }
    }
  },
  computed: {
    dataSourceOrderPhase () {
      const res = this.API('OrderPhases/GetAllDynamic?select=id,title&orderBy=title')
      return { ...res, records: [{ id: 'ACTIVE', title: this.L10n('active') }, ...res.records] }
    },
    dataSourceCustomFilters () {
      return [
        { id: '(priority==null) ? true : (priority.isCritical==true)', title: this.L10n('critical-priority') },
        { id: 'coreReceived==true', title: this.L10n('core-received-true') },
        { id: 'coreReceived!=true', title: this.L10n('core-received-false') }
      ]
    },
    columnsPart () {
      return [
        { title: this.L10n('part-number'), value: 'partNumber', originField: 'partNumber', type: 'custom', customFilter: filterStartsWith },
        { title: this.L10n('part-description'), value: 'partDescription', originField: 'partDescription', type: 'custom', customFilter: filterStartsWith },
        { title: this.L10n('remark'), value: 'remark' }
      ]
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&OrderBy=name')
    }
  },
  methods: {
    mixHookOnFilter (filterValue) {
      this.$bus.$emit('customer-po-followup-on-filter', filterValue)
    }
  }
}
</script>
